import React from "react";
import withStyles from '@mui/styles/withStyles';
import { useSelector, useDispatch } from "react-redux";
import { showLoader, hideLoader } from "actions/loader";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import Context from "../aiGeneratedImagesContext";
import {
  Container,
  FooterActions,
  RadiosWrapper,
  StyledImageWrapper,
  Note,
} from "styles/components/ArtWork/saveai-images-to-library";

const styles = (theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography {...other}>
      <Typography variant="h6">{children}</Typography>
      <IconButton className={classes.closeButton} onClick={onClose} size="large">
        <CloseIcon />
      </IconButton>
    </MuiDialogTitle>
  );
});

const SaveAIImagesToLibrary = ({ reload }) => {
  const dispatch = useDispatch();
  const emailid = useSelector((state) => state?.auth?.profile?.emailid);

  const { state, setState } = Context();
  const [value, setValue] = React.useState("1");

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  if (!state?.saveAIImagesToLibrary) return null;

  const handleClose = () =>
    setState({ ...state, saveAIImagesToLibrary: false });

  const save = async () => {
    const API_ENDPOINT =
      "https://api.cloudinary.com/v1_1/big-oven-tees-inc/upload";
    const fileData = new FormData();
    fileData.append("file", state?.saveAIImagesToLibrary);
    fileData.append("upload_preset", "tnedst8q");
    fileData.append("folder", `Shirtly/${emailid}/AIArtFiles`);
    dispatch(showLoader());
    await fetch(API_ENDPOINT, {
      method: "post",
      body: fileData,
    });
    dispatch(hideLoader());

    handleClose();

    if (value === "1") {
      reload();
    }

    alert("Your selected image has been saved to AI Library.");
  };

  return (
    <Dialog onClose={handleClose} open>
      <Container>
        <DialogTitle onClose={handleClose}>Save to Library</DialogTitle>
        <MuiDialogContent dividers>
          <StyledImageWrapper>
            <img src={state?.saveAIImagesToLibrary} alt="" />
          </StyledImageWrapper>
          <RadiosWrapper>
            <FormControl component="fieldset">
              <RadioGroup name="gender1" value={value} onChange={handleChange}>
                <FormControlLabel
                  value={"1"}
                  control={<Radio />}
                  label="Save to the library, I want to use this design for mockups"
                />
                <FormControlLabel
                  value={"2"}
                  control={<Radio />}
                  label="Save to the library and continue generating more AI images."
                />
              </RadioGroup>
            </FormControl>
          </RadiosWrapper>
          {/* {value === "1" && (
            <Note>
              This will end the session and will clear the session history.
            </Note>
          )} */}
        </MuiDialogContent>
        <MuiDialogActions>
          <FooterActions>
            <Button variant="contained" onClick={save} color="primary">
              Save
            </Button>
          </FooterActions>
        </MuiDialogActions>
      </Container>
    </Dialog>
  );
};

export default SaveAIImagesToLibrary;
